module.exports = __webpack_public_path__ + "static/img/Elena.54d82e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Elena.jpg
// module id = Csd+
// module chunks = 3